import { render, staticRenderFns } from "./CrmUserBenefits.vue?vue&type=template&id=fafd436e&scoped=true&"
import script from "./CrmUserBenefits.vue?vue&type=script&lang=js&"
export * from "./CrmUserBenefits.vue?vue&type=script&lang=js&"
import style0 from "./CrmUserBenefits.vue?vue&type=style&index=0&id=fafd436e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafd436e",
  null
  
)

export default component.exports